import styled, { css } from 'styled-components';
import { F as Flex } from '../Flex/Flex-DZMfgrzg.js';

const borderRadiusMixin = ({
  theme,
  value,
  max,
  $radius
}) => {
  if (value === max) {
    return css(["border-radius:", ";"], theme.border.radius.round);
  }
  return $radius === 'round' ? css(["/*! @noflip */ border-radius:", ";"], theme.border.radius.round) : css(["/*! @noflip */ border-radius:", " 0 0 ", ";"], theme.border.radius.round, theme.border.radius.round);
};

/** Separated out due to issues with styled-components not setting rtl styles properly */
const borderRadiusRTLMixin = ({
  theme,
  value,
  max
}) => {
  if (value === max) {
    return css(["border-radius:", ";"], theme.border.radius.round);
  }
  return css(["/*! @noflip */ border-radius:0 ", " ", " 0;"], theme.border.radius.round, theme.border.radius.round);
};
const getColorFromTheme = ({
  theme,
  $status,
  $colorValue
}) => {
  if ($status === 'error') {
    return theme.progressIndicator.valueColor.error[$colorValue];
  }
  if ($status === 'warning') {
    return theme.progressIndicator.valueColor.warning[$colorValue];
  }
  return theme.progressIndicator.valueColor.default[$colorValue];
};
const ProgressContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-1174sv-0"
})(["", ";width:100%;"], ({
  $inline
}) => $inline ? css(["display:flex;align-items:center;flex-direction:row;justify-content:flex-start;gap:", ";"], ({
  theme
}) => theme.spacing.xxxsmall.default) : css(["display:block;"]));
const tickBackgroundMixin = /*#__PURE__*/css(["content:\"\";background-color:", ";height:", ";position:absolute;top:", ";width:", ";"], ({
  theme
}) => theme.progressIndicator.trackColor, ({
  $size,
  theme
}) => theme.progressIndicator.trackHeight[$size], ({
  $size,
  theme
}) => `calc(calc(${theme.progressIndicator.tick.height} / 2) - calc(${theme.progressIndicator.trackHeight[$size]} / 2))`, ({
  theme
}) => theme.progressIndicator.tick.paddingInline);
const Tick = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-1174sv-1"
})(["position:absolute;width:", ";height:", ";background-color:", ";left:", "%;inset-inline-start:", "%;right:auto;inset-inline-end:auto;[dir=\"rtl\"] &&{right:", "%;inset-inline-start ", "%;left:auto;inset-inline-end:auto;}", ""], ({
  theme
}) => theme.progressIndicator.tick.width, ({
  theme
}) => theme.progressIndicator.tick.height, ({
  theme
}) => theme.border.color.medium.active, ({
  $targetValue
}) => $targetValue, ({
  $targetValue
}) => $targetValue, ({
  $targetValue
}) => $targetValue, ({
  $targetValue
}) => $targetValue, ({
  $targetValue,
  $value,
  theme
}) => $value > $targetValue && css(["::before{right:", ";", "}::after{left:", ";", "}"], theme.progressIndicator.tick.paddingInline, tickBackgroundMixin, theme.progressIndicator.tick.paddingInline, tickBackgroundMixin));
// Note: Firefox does not give a means of styling the <progress> container.
// Currently only webkit supports animations on the progress bar itself.
const Progress = /*#__PURE__*/styled('progress').withConfig({
  componentId: "sc-storm-ui-40027066__sc-1174sv-2"
})(["-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:", ";border:none;border-radius:", ";color:", ";height:", ";width:100%;::-webkit-progress-bar{background-color:", ";border-radius:", ";@media (prefers-reduced-motion:no-preference){transition:", ";}}::-webkit-progress-value{background-color:", ";", ";@media ( prefers-reduced-motion:no-preference){transition:", ";}}::-moz-progress-bar{background-color:", ";", ";@media ( prefers-reduced-motion:no-preference){transition:", ";}}/*! @noflip */ [dir=\"rtl\"] &{::-webkit-progress-value{", "}::-moz-progress-bar{", "}}"], ({
  theme
}) => theme.progressIndicator.trackColor, ({
  theme
}) => theme.border.radius.round, getColorFromTheme, ({
  theme,
  $size
}) => theme.progressIndicator.trackHeight[$size], ({
  theme
}) => theme.progressIndicator.trackColor, ({
  theme
}) => theme.border.radius.round, ({
  theme
}) => theme.progressIndicator.widthTransition, getColorFromTheme, borderRadiusMixin, ({
  theme
}) => theme.progressIndicator.widthTransition, getColorFromTheme, borderRadiusMixin, ({
  theme
}) => theme.progressIndicator.widthTransition, borderRadiusRTLMixin, borderRadiusRTLMixin);
const Container = /*#__PURE__*/styled(Flex).withConfig({
  componentId: "sc-storm-ui-40027066__sc-1174sv-3"
})(["position:relative;width:100%;& > ", ":not(:first-child){position:absolute;background-color:transparent;::-webkit-progress-bar{background-color:transparent;}}"], Progress);
// @TODO: (storm-v4) update ink token

export { Container as C, ProgressContainer as P, Tick as T, Progress as a };
//# sourceMappingURL=ProgressIndicator.styles-8p6WbHkw.js.map
